<button
  class="sol-button-base"
  [class]="class$()"
  [class.sol-button-icon-32]="isIcon$() && !isSmall$()"
  [class.sol-button-icon-20]="isIcon$() && isSmall$()"
  [class.sol-button-loading]="loading$()"
  [class.sol-button-split]="hasDropdown$()"
  [disabled]="disabled$()"
  [attr.aria-label]="ariaLabel$()"
  (click)="click($event)"
  (auxclick)="auxclick($event)"
>
  @if (icon$()) {
    <sol-icon class="sol-button-part-icon" [name]="icon$()" />
  }
  @if (!isIcon$()) {
    @if (isCustom$()) {
      <span><ng-content /></span>
    } @else {
      <span>{{ text$() | translate }}</span>
    }
    @if (appendIcon$()) {
      <sol-icon class="sol-button-part-icon" [name]="appendIcon$()" />
    }
  }
  @if (loading$()) {
    <sol-spinner class="sol-button-part-icon sol-button-loading-icon" />
  }
</button>
@if (hasDropdown$()) {
  <button
    class="sol-button-base sol-button-dropdown-chevron"
    [class]="class$()"
    [disabled]="disabled$()"
    [attr.aria-label]="'sol-button.open-dropdown' | translate"
    (click)="dropdownChevronClick($event)"
  >
    <sol-icon class="sol-button-part-icon" [name]="SolIcon.chevron_down" />
  </button>
}
